import { useMemo } from "react";
import { Settings } from "../helpers/settings";
import { useSettings } from "./settings";

export const useFeatures = (): NonNullable<Settings["features"]> => {
  const [settings] = useSettings();
  // Env-provided features flow through the settings env layer (SETTINGS var).
  return useMemo(() => settings.features ?? {}, [settings.features]);
};
